import { Component, OnInit, ViewChild, AfterViewInit, Input, ChangeDetectorRef } from '@angular/core';
import { DailyDateRangeSelectorComponent } from '../daily-date-range-selector/daily-date-range-selector.component';
import { FormBuilder, FormGroup, Validators, FormArray, AbstractControl, FormControl, ValidationErrors, ControlContainer, NgForm } from '@angular/forms';
import { BehaviorSubject, Subscription } from 'rxjs';
import { BhpSelectorData } from '../_models/bhp-selector';

@Component({
  selector: 'app-bhp-period-method-selector',
  templateUrl: './bhp-period-method-selector.component.html',
  styleUrls: ['./bhp-period-method-selector.component.css']
})
export class BhpPeriodMethodSelectorComponent implements OnInit {

  @ViewChild("dateRangeSelector") dateRangeSelector: DailyDateRangeSelectorComponent;

  beginDate: BehaviorSubject<Date> = new BehaviorSubject<Date>(null);
  endDate: BehaviorSubject<Date> = new BehaviorSubject<Date>(null);

  beginDateSubscription: Subscription;
  endDateSubscription: Subscription;
  measurementMethodSubscription: Subscription;
  useOldDataSubscription: Subscription;

  dateBoundsSelectionForm: FormGroup;
  methodForm: FormGroup;
  useOldDataForm: FormGroup;

  dateRangeMode: string = "multi";

  @Input()
  bhpSelectorData: BhpSelectorData;

  constructor(private formBuilder: FormBuilder, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.dateBoundsSelectionForm = this.formBuilder.group({
    });

    this.useOldDataForm = this.formBuilder.group({
      'useOldInjectionValues': [false, []]
    });

    this.useOldDataSubscription = this.useOldDataForm.controls['useOldInjectionValues'].valueChanges.subscribe((newValue) => {

      this.bhpSelectorData.useLastInjData = newValue;
    });


    this.methodForm = this.formBuilder.group({
      'bhpMeasurementMethod': [null, Validators.required]
    });

    this.measurementMethodSubscription = this.methodForm.controls['bhpMeasurementMethod'].valueChanges.subscribe((newValue) => {

      if (newValue == 1 || newValue == 2) {
        this.dateRangeMode = "single";
      }
      else if (newValue == 3) {
        this.dateRangeMode = "multi";
      }
      this.bhpSelectorData.methodId = newValue;
    });
  }

  ngAfterViewInit(): void {
    this.initDateBoundsSelectionForm();
    this.cdr.detectChanges();
  }

  initDateBoundsSelectionForm() {
    this.dateBoundsSelectionForm.addControl('dateBoundsSelectionForm', this.dateRangeSelector.dateBoundsSelectionForm);

    this.beginDateSubscription = this.dateBoundsSelectionForm.controls.dateBoundsSelectionForm.get("BeginDate").valueChanges.subscribe((newValue) => {
      this.beginDate.next(newValue);
      this.bhpSelectorData.beginDate = newValue;
    });

    this.endDateSubscription = this.dateBoundsSelectionForm.controls.dateBoundsSelectionForm.get("EndDate").valueChanges.subscribe((newValue) => {
      this.endDate.next(newValue);
      this.bhpSelectorData.endDate = newValue;
    });

    //We have to manually grab these values initially.

    let initBeginDate = this.dateBoundsSelectionForm.controls.dateBoundsSelectionForm.get("BeginDate").value;
    this.beginDate.next(initBeginDate);
    this.bhpSelectorData.beginDate = initBeginDate;


    let initEndDate = this.dateBoundsSelectionForm.controls.dateBoundsSelectionForm.get("EndDate").value;
    this.endDate.next(initEndDate);
    this.bhpSelectorData.endDate = initEndDate;
  }

  ngOnDestroy(): void {
    if (this.beginDateSubscription != null) {
      this.beginDateSubscription.unsubscribe();

      this.beginDateSubscription = null;
    }

    if (this.endDateSubscription != null) {
      this.endDateSubscription.unsubscribe();

      this.endDateSubscription = null;
    }

    if (this.measurementMethodSubscription != null) {
      this.measurementMethodSubscription.unsubscribe();
    }
    this.measurementMethodSubscription = null;
  }

}
